module.exports = "pegasus_template/assets/blocks/pop-up-layout-imagetextform-02.png";